<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western2" id="calibre_pb_7"><a id="Chapter01"></a>
Chapter 1</h1>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c6">It never occurred to me to look up until it was too
late. Someone jumped down, landing hard on my back. I fell forward
and the wind was knocked out of me. Another launched himself down
at Rider. Rider dodged out of the way and rolled to my side. He
kicked the guy on top of me hard in the ribs. The guy cried out and
pulled a gun from his side holster.</p>
<p class="western1">“No!” I shouted. I struggled to get my own
weapon. The other guy was faster. My fingers closed on my knife
right as the shot rang out. Birds took flight, the flapping of
their wings echoing off the trees. Rider fell to his knees, his
hands on his stomach. Blood pooled around his fingers.</p>
<p class="western1">“No!” I screamed again. I closed my hand
around the knife and sprang up. “Rider!” I cried, rushing over to
him. Tears blurred my vision.</p>
<p class="western1">“Riss,” he muttered and started coughing.
Blood bubbled from his lips.</p>
<p class="western1">I crawled to him, crying. He reached out for
me and just as our fingers touched, I was jerked away. I swung my
hand around and made contact with whoever had a handful of my hair.
He yelled and kicked me in the back, his foot hitting my
kidney.</p>
<p class="western1">I thrashed forward, desperately wanting to
get away and get to Rider. I raised my hand again and brought the
point of the knife down on the guy’s foot.</p>
<p class="western1">“Dumb bitch,” he said and grabbed my wrist.
The guy who shot Rider walked over. He laughed when he saw me
struggling.</p>
<p class="western1">“This one seems like fun,” he said and kicked
the knife from my hand.</p>
<p class="western1">“I will kill you both!” I threatened. I
elbowed the guy who was holding me in the ribs and brought my foot
up to smash his balls. His grip on my hair loosened and I was able
to pull away. The other guy leaned in to grab me. I reached behind
me to get the M9 but it wasn’t there. It must have fallen out when
the bastard landed on me.</p>
<p class="western1">I didn’t have time to get the M16 from around
my neck. Something stuck me in the back of the head. Stunned, I
wavered. Then I felt a heavy blow to my knees, causing me to fall.
I made one last attempt to get to Rider, who was coughing and
gurgling up blood.</p>
<p class="western1">“I’m sorry,” I cried. My fingers closed
around his. He gave them one last squeeze. I made a mad grab for
his pistol. I grabbed it, aimed at my attacker and pulled the
trigger.</p>
<p class="western1">Nothing happened. Unlike me, Rider was smart
and kept his safety on. From behind, someone kicked me in the side
and then kicked the pistol out of my hands. He raised his foot and
it came crashing down on my ribs. A horrible, biting, sharp pain
flooded my body. It hurt so bad I could barely breathe.</p>
<p class="western1">Hands harshly grabbed a handful of my hair
and pulled me back, dragging me over the rough ground. I cried out
in protest and in pain when another blow came to my ribcage. Heavy,
rough hands gripped my arms.</p>
<p class="western1">The guy who attacked Rider picked up my
pistol and hit me in the temple. My vision was fuzzy and blood
dripped in my face. I struggled to get away, trying to twist and
sink my fingernails into my attacker’s skin.</p>
<p class="western1">I couldn’t get my feet to work properly. I
was a couple yards away from Rider now. I reached up and dug my
nails into the guys arm.</p>
<p class="western1">“Ah!” he yelled. I heard the familiar sound
of a magazine sliding into a gun. The guy stopped dragging me. I
felt a bone shattering pain in the back of my head.</p>
<p class="western1">And then everything went black.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_0a9fca13b620a2de592dddca89bae7c7_34PU7E.ch.fixed.fc.tidied.stylehacked.xfixed_split_008.vue?3064d5e5